import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { ExitToApp, ExpandLess, ExpandMore } from "@material-ui/icons";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DeleteIcon from "@material-ui/icons/Delete";
import DescriptionIcon from "@material-ui/icons/Description";
import InboxIcon from "@material-ui/icons/Inbox";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";
import ShowChartIcon from '@material-ui/icons/ShowChart';
import NotificationIcon from "components/notification/NotificationIcon";
import UserAvatar from "components/user/UserAvatar";
import { format } from "date-fns";
import {
  boiDepartmentId,
  drawerAdminWidth,
  NotificationType,
  platformName,
  RoleId
} from "libs/configs/constant";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  getNotifications,
  readNotifications,
  selectUnReadNotification,
  trashNotifications
} from "redux/modules/adminNotificationSlice";
import { selectIsBOI } from "redux/modules/authSlice";
import { getSmartForm, setSmartServiceId } from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerAdminWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerAdminWidth,
    backgroundImage: `linear-gradient(to bottom, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  iconButton: {
    color: "white",
  },
  warpUserInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 15,
  },
  warpUserName: {
    textAlign: "center",
    marginTop: 15,
    color: "white",
    fontSize: 18,
    fontWeight: 500,
  },
  warpUserRole: {
    textAlign: "center",
    marginTop: 5,
    color: "white",
    fontSize: 15,
    fontWeight: 400,
  },
  userInfo: {
    marginLeft: 10,
    color: "white",
  },
  warpLogo: {
    textAlign: "center",
    marginTop: 15,
  },
  adminLogo: {
    width: 45,
    height: 45,
  },
  warpNav: {
    backgroundColor: "#2C8AB9",
    marginTop: 15,
    color: "white",
  },
  navIcon: {
    color: "white",
    // fontSize:
  },
  nested: {
    paddingLeft: theme.spacing(10),
    fontSize: 14,
    color: "white",
  },
  textNav: {
    fontSize: 14,
  },
  // popover: {
  //   pointerEvents: 'none',

  // },
  // popoverContent: {
  //   // pointerEvents: 'auto',
  // },
  rowMenuPopOver: {
    // padding: 15,
    width: 350,
  },
  rowPopTitle: {
    padding: "15px",
    borderBottom: "1px solid lightgray",
    fontWeight: "500",
    color: "white",
    textAlign: "center",
    backgroundColor: "#F53C56",
    marginBottom: 15,
  },
  rowPopItem: {
    display: "flex",
    padding: "10px 15px",
    borderBottom: "1px solid lightgray",
    cursor: "pointer",
  },
  firstItem: {
    flex: 1,
  },
  itemTitle: {
    color: "#5F5F5F",
    fontWeight: "bold",
  },
  itemDesc: {
    color: "#5F5F5F",
    fontSize: "0.8rem",
    paddingTop: "10px",
    fontWeight: "500",
  },
  itemDate: {
    color: "#ABAFC9",
    fontSize: "0.8rem",
    paddingTop: "10px",
    fontWeight: "500",
  },
  secItem: {
    width: 23,
    color: "#F53C56",
    cursor: "pointer",
  },
  noNoti: {
    textAlign: "center",
    color: "#ABAFC9",
    paddingBottom: "18px",
  },
}));

export default function SidebarAdminLeft(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();

  const { list: notifications } = useSelector(
    (state) => state.adminNotification
  );
  const [anchorEl, setAnchorEl] = useState(null);

  const unread = useSelector(selectUnReadNotification);
  const profile = useSelector((state) => state.user.profile);

  const auth = useSelector((state) => state.auth);

  const isOfflineLogin = auth?.isOfflineLogin || false;

  const menu = [
    {
      title: "Dashboard",
      icon: <DashboardIcon className={classes.navIcon} />,
      to: "/admin/dashboard",
      actionNo: "A023",
      allDepart: true,
    },
    {
      title: "KPI Dashboard",
      icon: <ShowChartIcon className={classes.navIcon} />,
      to: "/admin/kpi-dashboard",
      actionNo: "A037",
      allDepart: false,
    },
    {
      title: "LTR VISA",
      icon: <InboxIcon className={classes.navIcon} />,
      children: [
        {
          title: "All Documents",
          to: "/admin/smart-visa/all-documents",
          actionNo: "A024",
          allDepart: true,
        },
        profile?.departmentId === boiDepartmentId && {
          title: "Preapprove",
          to: "/admin/smart-visa/preapprovelist",
          actionNo: "A024",
          allDepart: true,
        },
        {
          title: "Stamp Appointment",
          to: "/admin/smart-visa/issuance-appointment",
          actionNo: "A025",
          allDepart: true,
        },
      ],
    },
    {
      title: "Setting",
      icon: <SettingsIcon className={classes.navIcon} />,
      children: [
        {
          title: "ตั้งค่าหน่วยงานรับรองอนุมัติเอกสาร",
          to: "/admin/setting/configsmartservice",
          actionNo: "A026",
          allDepart: false,
        },
        {
          title: "List Personal",
          to: "/admin/setting/listpersonal",
          actionNo: "A036",
          allDepart: false,
        },
        {
          title: "Holidays",
          to: "/admin/setting/holidays",
          actionNo: "A027",
          allDepart: false,
        },
        {
          title: "Manage User",
          to: "/admin/setting/manage-user",
          actionNo: "A028",
          allDepart: true,
        },
        {
          title: "Email Log",
          to: "/admin/setting/emailLog",
          actionNo: "A028",
          allDepart: true,
        },
        {
          title: "สิทธิ์การเข้าถึง",
          to: "/admin/setting/permission",
          actionNo: "A029",
        },
        {
          title: "จัดการผู้รักษาการแทน",
          to: "/admin/setting/surrogate",
          actionNo: "A030",
          allDepart: true,
        },
        {
          title: "จัดการหน่วยงานรับรอง",
          to: "/admin/setting/department",
          actionNo: "A031",
          allDepart: false,
        },
        {
          title: "กำหนดเวลาคำขอ",
          to: "/admin/setting/config-request",
          actionNo: "A032",
          allDepart: false,
        },
        {
          title: "โอนงาน",
          to: "/admin/setting/transfer-job",
          actionNo: "A033",
          allDepart: true,
        },
        {
          title: "ตั้งค่าเรื่องที่ตรวจสอบ",
          to: "/admin/setting/config-department-action",
          actionNo: "A034",
          allDepart: true,
        },

        {
          title: "ตั้งค่าตัวแทน",
          to: "/admin/setting/agencylist",
          actionNo: "A035",
          allDepart: true,
        },
      ],
    },
    {
      title: "Report",
      icon: <DescriptionIcon className={classes.navIcon} />,
      to: "/admin/report/industry",
      actionNo: "A034",
      allDepart: false,
    },

  ];

  const handleDrawerClose = () => {
    props.onDrawerClose();
  };

  const handleLogout = () => {
    if (isOfflineLogin) {
      history.replace("/logout");
    } else {
      history.replace("/logout");
      // logoutRedirect();
    }
  };

  const popoverClick = async (e) => {
    if (open) {
      setAnchorEl(null);
    } else {
      setAnchorEl(e.currentTarget);
      if (unread.length > 0) {
        const body = {
          deviceId: platformName,
          notificationIds: unread.map((x) => x.notificationId),
        };
        await dispatch(readNotifications(body));
        await dispatch(getNotifications());
      }
    }
  };

  const popoverLeave = async () => {
    setAnchorEl(null);
  };

  const removeNotificaiton = async (notificationId) => {
    const body = {
      deviceId: platformName,
      notificationIds: [notificationId],
    };

    await dispatch(trashNotifications(body));
    await dispatch(getNotifications());
  };

  const onSelectNoti = async (noti) => {
    console.log(noti.type);

    if (noti.data) {
      const data = JSON.parse(noti.data);
      if (noti.type === NotificationType.RequestDocuments) {
        // request additional documents
        history.push(`/admin/smart-visa/document/${data.draftId}`);
      }
    }
    if (noti.type === "Stamped" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/appointment/${notiData?.DraftId}`);
    }
    if (noti.type === "StampFromReview" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);

      history.push(`/admin/smart-visa/preapprove/${notiData?.draftId}`);
    }
    if (noti.type === "RequestDocPreapprove" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);

      history.push(`/admin/smart-visa/preapprove/${notiData?.draftId}`);
    }
    if (noti.type === "ConfirmStamped" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/appointment/${notiData?.DraftId}`);
    }
    if (noti.type === "UploadDocument" && noti?.data !== null) {
      try {
        const notiData = JSON.parse(noti.data);

        setAnchorEl(null);
        history.push(`/admin/smart-visa/document/${notiData?.draftId}`);

        dispatch(setSmartServiceId(notiData.smartServiceId));
        dispatch(
          getSmartForm({
            personalId: notiData.personalId,
            smartserviceId: notiData.smartServiceId,
            draftId: notiData.draftId,
          })
        );
      } catch (e) {
        console.log("handleClickNotiItem ", e);
      }
    }
    if (noti.type === "PersonalSentRequest" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
    }
    if (noti.type === "BOISentOtherDep" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
    }

    if (noti.type === "DocumentApproved" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
    }

    if (noti.type === "FinalApproved" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
    }

    if (noti.type === "ConfirmStampFile" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/appointment/${notiData?.DraftId}`);
    }

    if (noti.type === "ApprovedStamp" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/appointment/${notiData?.DraftId}`);
    }

    if (noti.type === "SentManager" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
    }

    if (noti.type === "Reassign" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
    }

    if (noti.type === "BOIRejected" && noti?.data !== null) {
      const notiData = JSON.parse(noti.data);
      history.push(`/admin/smart-visa/document/${notiData?.draftId}`);
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="left"
      open={props.open}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.drawerHeader}>
        <IconButton className={classes.iconButton} onClick={handleDrawerClose}>
          {theme.direction === "ltr" ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </div>
      <Divider />

      <div className={classes.warpUserInfo}>
        <div className={classes.userInfo} onClick={(e) => popoverClick(e)}>
          <NotificationIcon
            className={classes.userInfo}
            count={unread.length}
          />
        </div>
        <div className={classes.userInfo}>
          <Link
            to={`/admin/setting/employee/${profile.userID}`}
            style={{ textDecoration: "none" }}
          >
            <UserAvatar size={7} className={classes.userInfo} />
          </Link>
        </div>
        <div className={classes.userInfo}>
          <Link to={`/admin/setting/employee/${profile.userID}`}>
            <PersonIcon className={classes.userInfo} />
          </Link>
        </div>
      </div>

      <div className={classes.warpUserName}>
        {profile.firstname} {profile.lastName}
      </div>
      <div className={classes.warpUserRole}>{profile.roleName}</div>
      <div className={classes.warpLogo}>
        <img
          src={"/assets/images/admin-logo.png"}
          alt="icon-search"
          className={classes.adminLogo}
        />
      </div>

      <div className={classes.warpNav}>
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          className={classes.root}
        >
          {menu.map((m) => {
            return (
              <CollapseListItem key={m.title} {...m} history={props.history} />
            );
          })}
          <ListItem button onClick={handleLogout}>
            <ListItemIcon>
              <ExitToApp className={classes.navIcon} />
            </ListItemIcon>
            <ListItemText
              primary="Logout"
              classes={{ primary: classes.textNav }}
            />
          </ListItem>
        </List>
      </div>

      <Popover
        className={classes.popover}
        classes={{
          paper: classes.popoverContent,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={popoverLeave}
      >
        <div className={classes.rowMenuPopOver}>
          <div className={classes.rowPopTitle}>Notifications</div>
          {notifications.length > 0 &&
            notifications.map((noti, index) => (
              <div
                key={noti.notificationId}
                className={classes.rowPopItem}
                onClick={() => onSelectNoti(noti)}
              >
                <div className={classes.firstItem}>
                  <div className={classes.itemTitle}>{noti.title}</div>
                  <div className={classes.itemDesc}>{noti.description}</div>
                  <div className={classes.itemDate}>
                    {format(new Date(noti.createDate), "yyyy-MM-dd HH:mm")}
                  </div>
                </div>
                <div
                  className={classes.secItem}
                  onClick={() => removeNotificaiton(noti.notificationId)}
                >
                  <DeleteIcon />
                </div>
              </div>
            ))}
          {notifications.length === 0 && (
            <div className={classes.noNoti}>No notifications yet</div>
          )}
        </div>
      </Popover>
    </Drawer>
  );
}

export function CollapseListItem(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const history = useHistory();
  const { allActionsUser } = useSelector((state) => state.configAction);
  const isBOI = useSelector(selectIsBOI);
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });

  function HandleClick() {
    if (props.to) {
      history.push(props.to);
    } else {
      setOpen(!open);
    }
  }

  const hasChildren = () => {
    return props.children && props.children.length > 0;
  };
  return (
    <React.Fragment>
      <ListItem button onClick={HandleClick}>
        <ListItemIcon>{props.icon}</ListItemIcon>
        <ListItemText
          primary={props.title}
          classes={{ primary: classes.textNav }}
          button
          component={Link}
          to={props.to}
        />
        {hasChildren() && (open ? <ExpandLess /> : <ExpandMore />)}
      </ListItem>

      <Collapse in={open && hasChildren()} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {props.children &&
            props.children.map((c) => {
              if (
                (allActionsUser.map((x) => x.actionNo).indexOf(c.actionNo) >
                  -1 &&
                  ((c.allDepart === false && isBOI) || c.allDepart === true)) ||
                (c.allDepart === true && Role === RoleId.Admin)
              ) {
                return (
                  <ListItem
                    key={c.title}
                    button
                    className={classes.nested}
                    component={Link}
                    to={c.to}
                  >
                    <ListItemText
                      primary={c.title}
                      classes={{ primary: classes.textNav }}
                    />
                  </ListItem>
                );
              }
            })}
        </List>
      </Collapse>
    </React.Fragment>
  );
}
